var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('iframe',{attrs:{"width":"100%","src":_vm.url,"onload":"iFrameResize({}, this)"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }